import { odooApi } from '../index';
import { getOdooLang } from '@/config/api.config';
import { extractErrorMessage } from '../transforms';

/**
 * Gulf Cup API Endpoints (Connected to Odoo Backend)
 * 
 * This file contains Gulf Cup championship API endpoints.
 * Connected to real Odoo API at /api/moys/gulf-cup
 */

export interface GulfCupTitle {
  year: number;
  city: string;
  country: string;
  titleName: string;
}

export interface GulfCup {
  id: string;
  name: string;
  edition: number;
  hostCountry: string;
  hostCity: string;
  startDate: string;
  endDate: string;
  description: string;
  titles: GulfCupTitle[];
}

export const gulfCupApi = odooApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get Gulf Cup information from Odoo
    getGulfCup: builder.query<GulfCup[], { lang?: 'ar' | 'en' | 'ku' }>({
      query: ({ lang = 'ar' }) => {
        const odooLang = getOdooLang(lang);
        
        return {
          url: `/api/moys/gulf-cup?lang=${odooLang}`,
          method: 'POST',
        };
      },
      transformResponse: (response: any) => {
        try {
          if (!response.success || !response.data) {
            throw new Error('Invalid response format');
          }
          
          return response.data.map((item: any) => ({
            id: String(item.id),
            name: item.name || '',
            edition: item.edition || 0,
            hostCountry: item.host_country || '',
            hostCity: item.host_city && item.host_city !== false ? item.host_city : '',
            startDate: item.start_date || '',
            endDate: item.end_date || '',
            description: item.description || '',
            titles: (item.titles || [])
              .map((title: any) => ({
                year: title.year || 0,
                city: title.city || '',
                country: title.country || '',
                titleName: title.title_name || '',
              }))
              .sort((a: any, b: any) => (b.year || 0) - (a.year || 0)), // Sort by year descending
          })) as GulfCup[];
        } catch (error) {
          console.error('[Gulf Cup API] Transform error:', error);
          throw error;
        }
      },
      transformErrorResponse: (response) => {
        return extractErrorMessage(response);
      },
      providesTags: ['Settings'],
    }),
  }),
});

export const {
  useGetGulfCupQuery,
} = gulfCupApi;

